import { render, staticRenderFns } from "./DataTablesSelectorComponent.vue?vue&type=template&id=4a034797&"
import script from "./DataTablesSelectorComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesSelectorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports